<template lang="pug">
  #pedidos-home
    transition(name="animate-css" enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" mode="out-in")
      router-view
</template>

<script>

export default {
  name: 'PedidosHome',
  components: {},
  data () {
    return {
    }
  },
  computed: {
  },
  created () {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
</style>
